// Configuration file for What's New items
// This file contains all the items that will be displayed in the What's New modal
// You can easily add, remove, or modify items by editing this array

export const whatsNewItems = [
  {
    id: 4,
    title: "Deploy Pipelines — Build & Deploy On Demand",
    description: "Pipelines give you one place to rebuild a container image from source and deploy it to its App Instance container — in a single step, whenever you need it. Set a pipeline up once, then trigger a build-and-deploy on demand, watch it progress live, and review the full run history.",
    category: "New Feature",
    image: "",
    features: [
      "Create a pipeline linking a source image to its target App Instance container",
      "Trigger a build-and-deploy on demand — your git token is used only for that run and never stored",
      "A dedicated pipeline page visualises the flow: Source image → Build → Target container → Deploy → Latest run",
      "Watch the latest run advance live (Building → Deploying → Succeeded / Failed), with clear, honest failure states",
      "See the exact build coordinates each run uses — branch, Dockerfile path, repository and latest image tag",
      "Browse all your pipelines grouped by App Instance, with full run history per pipeline"
    ],
    date: "2026-07-20",
    actionText: "View Pipelines",
    actionUrl: "/pipelines",
    external: false
  },
  {
    id: 3,
    title: "App Packages Retired — Deploy Package-Free",
    description: "Creating and managing App Packages is no longer needed. Deploy your apps directly as App Instances with inline containers — the same result, fewer steps. The App Package area and its package sync/upgrade actions have now been fully retired from the portal.",
    category: "Breaking Change",
    image: "",
    features: [
      "Create deployments straight from App Instances — no separate package step",
      "The \"App Package\" navigation section, list/detail pages and create wizard have been removed",
      "Package sync / upgrade / dismiss actions on instances are retired",
      "Your existing app instances and your access to them are unchanged",
      "Any script or integration calling the api/app-packages endpoints now returns 404 — switch to the app-instance APIs"
    ],
    date: "2026-07-14",
    actionText: "Create an App Instance",
    actionUrl: "/app-instances",
    external: false
  },
  {
    id: 1,
    title: "Self-Serve Webhook Registration",
    description: "Register webhooks and action hooks yourself, directly in the portal — no more raising tickets or waiting on the JobLogic team. Point events at your endpoints, scope them per app or across all your apps, and go live in seconds.",
    category: "New Feature",
    image: "/assets/images/whats-new/webhook-registration.png",
    features: [
      "Choose between Action Hook (GET) and Webhook (POST) delivery",
      "Subscribe any endpoint to the events you care about",
      "Add optional custom request headers as JSON",
      "Target a single Marketplace App or apply to all your apps",
      "Manage and track every registration from one place"
    ],
    date: "2026-07-01",
    actionText: "Register a Webhook",
    actionUrl: "/webhook-registrations",
    external: false
  },
  {
    id: 2,
    title: "Enhanced Container App Log Viewer",
    description: "Diagnose issues faster with a redesigned log viewer for container apps. Search logs by keyword, filter by log level, and keep an eye on live deployments with auto-refresh — all without leaving the portal.",
    category: "Improvement",
    image: "/assets/images/whats-new/log-enhancement.png",
    features: [
      "Keyword search filters logs server-side in real time",
      "Multi-select log level filter (INFO, WARNING, ERROR, DEBUG, TRACE, EXCEPTION, FAILURE, OTHER)",
      "Auto-refresh with 30-second or 1-minute polling intervals",
      "Flexible date range: Last 30 minutes, 1 hour, 4 hours, 12 hours, or up to 30 days",
      "Pagination state preserved when switching tabs"
    ],
    date: "2026-05-08",
    actionText: "View Logs",
    actionUrl: "/app-instances",
    external: false
  }
];

// Helper function to get the latest items (useful for notifications or badges)
export const getLatestItems = (count = 3) => {
  return whatsNewItems
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, count);
};

// Helper function to get items by category
export const getItemsByCategory = (category) => {
  return whatsNewItems.filter(item => item.category === category);
};

// Helper function to add a new item (for admin/developer use)
export const addNewItem = (newItem) => {
  const item = {
    id: Math.max(...whatsNewItems.map(item => item.id)) + 1,
    date: new Date().toISOString().split('T')[0],
    ...newItem
  };
  whatsNewItems.unshift(item);
  return item;
};

// Helper function to remove an item
export const removeItem = (id) => {
  const index = whatsNewItems.findIndex(item => item.id === id);
  if (index > -1) {
    return whatsNewItems.splice(index, 1)[0];
  }
  return null;
};
